<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.aerators.updateHardware")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineAeratorHardwareForm :APIbaseURL="APIbaseURL" :hardware="hardware" :firmwares="firmwares" :bootloaders="bootloaders" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAeratorHardwareForm } from 'aveine-aerator'
import { FirmwareVersion, BootloaderVersion, HardwareVersion } from 'aveine-toolbox'
export default {
  data () {
    return {
      hardware: {},
      firmwares: [],
      bootloaders: [],
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineAeratorHardwareForm
  },
  async created() {
    await HardwareVersion.api().get(`hardware-versions/${this.$route.params.id}`, {
      params: {
        include: "latest-bootloader,latest-firmware"
      }
    });

    this.hardware = await HardwareVersion.query().whereId(this.$route.params.id).withAllRecursive().first();

    let reqFirmwares = await FirmwareVersion.api().get(`firmware-versions`)
    
    const that = this;

    reqFirmwares.response.data.map(async function(data){
      const firmware = await FirmwareVersion.query().whereId(data.id).withAllRecursive().first();
      that.firmwares.push({label: `${firmware.version}`, value: firmware});
    })

    let reqBootloaders = await BootloaderVersion.api().get(`bootloader-versions`)

    reqBootloaders.response.data.map(async function(data){
      const bootloader = await BootloaderVersion.query().whereId(data.id).withAllRecursive().first();
      that.bootloaders.push({label: `${bootloader.version}`, value: bootloader});
    })


    this.dataLoaded = true;
  },
}
</script>
